import React from "react";
import { Box, Alert, Typography, LinearProgress } from "@mui/material";

export const FormStatusAlert = ({ loadingFormData, isEditable, t }) => {
  if (loadingFormData) {
    return (
      <Box sx={{ maxWidth: 800, mx: "auto", mb: 3 }}>
        <Alert
          severity="info"
          sx={{
            borderRadius: 2,
            "& .MuiAlert-message": { width: "100%", pb: 0.5 },
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 500, mb: 1.25 }}>
            {t.loadingFormData}
          </Typography>
          <LinearProgress color="info" sx={{ borderRadius: 1, height: 3 }} />
        </Alert>
      </Box>
    );
  }

  if (!isEditable) {
    return (
      <Box sx={{ maxWidth: 800, mx: "auto", mb: 3 }}>
        <Alert severity="warning" sx={{ borderRadius: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {t.formNotEditable}
          </Typography>
        </Alert>
      </Box>
    );
  }

  return null;
};
